/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import NotificationGeneral from '@/components/notifications/NotificationGeneral'
import InputText from '@/components/forms/InputText'
import ScreenLoader from '@/components/loaders/ScreenLoader'

const ModalNickname = ({
  nickname,
  onClose,
  action,
  updateNickname
}) => {
  const title = action === 'Set'
    ? 'Set your Nickname'
    : 'Edit your Nickname'
  const [showNotification, setShowNotification] = useState(false)
  const [error, setError] = useState()
  const [message, setMessage] = useState()
  const {
    handleSubmit: handleSubmitNickname,
    register,
    formState: { isSubmitting }
  } = useForm()
  const onSubmit = async data => {
    updateNickname &&
      await updateNickname({
        nickname: data.nickname,
        setError,
        setMessage,
        setShowNotification
      })
  }
  const curOnClose = () => {
    onClose && onClose()
  }

  return (
    <Modal isOpen={true} onClose={curOnClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{ title }</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          { showNotification &&
            <NotificationGeneral
              className="mb-md"
              onClose={() => setShowNotification(false)}
              message={error}
              type={error ? 'error' : 'neutral'}
            />
          }
          { message
            ? <div className="text-center mt-sm">
                <div className="is-size-5">{ message }</div>
              </div>
            : <form onSubmit={handleSubmitNickname(onSubmit)}>
                { isSubmitting && <ScreenLoader /> }
                <div className="mb-md">
                  <InputText
                    name="nickname"
                    label="User Nickname"
                    defaultValue={nickname}
                    { ...register('nickname') }
                  />
                </div>
                <div>
                  <Button color="tertiary" onClick={onClose} className="mr-xs">Cancel</Button>
                  <Button type="submit">Save</Button>
                </div>
              </form>
          }
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ModalNickname
